import { render, staticRenderFns } from "./UncLoader.vue?vue&type=template&id=5bcc5594&scoped=true&"
import script from "./UncLoader.vue?vue&type=script&lang=js&"
export * from "./UncLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc5594",
  null
  
)

export default component.exports